import * as Y from 'yjs';

import { WidgetType } from 'shared/widgets/utils';

import { ManifestInitializedProps } from '@/types/ManifestType';
import { genRandId } from '@/utils/core.utils';
import { htmlToXmlFragment } from '@/utils/tiptap';

export function createNewBlockTitleData(content: string): ManifestInitializedProps {
  const id = genRandId();
  const fragment = htmlToXmlFragment(content);

  return [
    {
      id,
      contentObjectData: new Y.Map([
        ['id', id],
        ['type', WidgetType.BlockTitle],
        ['textType', 'header'],
        ['children', new Y.Array()],
        ['fragment', fragment],
        ['placeholder', ''],
        ['style', new Y.Map()]
      ])
    }
  ];
}
